// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".label-hotspot{width:200px;padding:.3em;font-size:16px;color:#4bb8d9;background-color:rgba(75,184,217,.75);border-radius:200px;font-weight:500;z-index:1;transform:translate(-50%,75%)!important}.label-hotspot .label{border-radius:200px;padding:.4em 1.5em;background-color:#fff}.label-hotspot.visited{color:#6a6a6a;background-color:hsla(192,5%,81%,.73)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
